export default "__VITE_ASSET__a76d9021__"